import React from 'react';
import review1 from '../../assets/images/reviewicon1.png';
import review2 from '../../assets/images/reviewicon2.png';
import review3 from '../../assets/images/reviewicon3.png';
// import { Link } from 'react-router-dom'
// import * as RT from '../../constants/Routing'
import PlaceHolderImg2x from '../../assets/images/placeholder@2x.png';

export default class ParticipantCard extends React.Component {
  constructor(props) {
    super(props);
    // console.log(this.props.task)
    this.state = {
      modalOpen: false
    };
  }

  // entryApproval = () => {
  //   // 応募承認関数を呼ぶ
  //   this.props.entryApproval(this.props.enterpriseId, this.props.token, this.props.taskId, this.props.taskrewId, this.props.participant.taskrewsId)
  // }

  // entryApprovalConfirm = () => {
  //   応募承認関数を呼ぶ
  //   this.setState({ modalOpen: true, modalTitle: 'このタスクルーの応募を承認しますか？' })
  // }

  modalClose = () => {
    this.setState({ modalOpen: false, modalTitle: '' });
  };

  _renderName = () => {
    return `${this.props.participant.lastName} ${this.props.participant.fastName}(${this.props.participant.lastNameKana} ${this.props.participant.fastNameKana})`;
  };

  _renderBtn = () => {
    const key = Number(this.props.participant.participant.key);
    console.log('TCL: ParticipantCard -> _renderBtn -> key', key);
    const shouldHide = this.props.noBtn;
    switch (key) {
      case 0:
        // 応募未承認のタスクルー
        if (shouldHide) {
          return null;
          break;
        }
      case 2: // 確定したタスクルー
      case 7: // キャンセル依頼
      case 3: // 勤務したタスクルー
        // case 6: // レビュー待ち
        return this.props.children;
      case 4: // 応募者からキャンセルしたタスクルー
      case 5: // 施設からキャンセルしたタスクルー
      case 1: // オファーしたタスクルー
      default:
        break;
    }
  };

  _renderOldReview = () => {
    const user = this.props.participant;
    const usersReview = user.participantReview;
    const { enterpriseReview } = user;
    let image = review1;
    if (usersReview != undefined) {
      if (usersReview.type == 1) {
        image = review1;
      } else if (usersReview.type == 2) {
        image = review2;
      } else {
        image = review3;
      }
    }
    if (this.props.oldReview) {
      return (
        <div className="row pt-5">
          <div className="col-6">
            <h4>このタスクでのこのタスクルーに対するレビュー</h4>
            <table className="table table-borderless">
              <tbody>
                {(() => {
                  if (enterpriseReview != null) {
                    return Object.entries(enterpriseReview.question).map(question => {
                      return (
                        <tr key={question[0]}>
                          <th className="question-title">{question[1].key}</th>
                          <td className="text-left">
                            <span className="review-value">{question[0] == "0" ? (question[1].value == "1" ? "未達成" : "タスク完了")
                                : question[1].value }</span>{question[0] == "0" ? "" : " / 5"}
                            </td>
                        </tr>
                      );
                    });
                  }
                })()}
                {(() => {
                  if (enterpriseReview != null) {
                    if (enterpriseReview.free) {
                      return (
                        <tr>
                          <th colSpan="2">その他ご意見</th>
                        </tr>
                      );
                    }
                  }
                })()}
                {(() => {
                  if (enterpriseReview != null) {
                    if (enterpriseReview.free) {
                      return (
                        <tr>
                          <td>{enterpriseReview.free}</td>
                        </tr>
                      );
                    }
                  }
                })()}
              </tbody>
            </table>
          </div>
          <div className="col-6">
            <h4>このタスクでのこのタスクルーからのレビュー</h4>
            {(() => {
              if (usersReview !== undefined && usersReview != null) {
                return (
                  <div className="row pt-5">
                    <div className="col-2">
                      <img src={image} className="loading-icon" alt="loading..." />
                    </div>
                    <div className="col-10">
                      <p>{usersReview.free}</p>
                    </div>
                  </div>
                );
              }
              return <p>まだタスクルーからレビューされていません。</p>;
            })()}
          </div>
        </div>
      );
    }
  };

  _renderConfirmTitle = () => {
    const key = Number(this.props.participant.participant.key);
    let title;
    switch (key) {
      case 0: // 応募未承認のタスクルー
        return (title = 'このタスクルーの応募を承認しますか？');
      case 3: // 勤務したタスクルー
        return;
      case 4: // キャンセルしたタスクルー
      case 5: // キャンセルしたタスクルー
        return;
      case 1: // オファーしたタスクルー
        return;
      default:
        break;
    }
    return title;
  };

  _renderConfirmClass = () => {
    const key = Number(this.props.participant.participant.key);
    let className;
    switch (key) {
      case 0: // 応募未承認のタスクルー
        return (className = 'apply-confirm-modal');
      case 3: // 勤務したタスクルー
        return;
      case 4: // キャンセルしたタスクルー
      case 5: // キャンセルしたタスクルー
        return;
      case 1: // オファーしたタスクルー
        return;
      default:
        break;
    }
    return className;
  };

  _renderImage = user => {
    if (user.photoId === '') {
      return null;
    } else if (!user.photoId) {
      return (
        <div className="col-sm-2 taskImage">
          <div
            className="task-icon task-icon-in-detail"
            style={{ backgroundImage: `url(${PlaceHolderImg2x})` }}
          ></div>
          <p>
            {'⭐️'}
            {'   '}
            {Math.round(this.props.participant.finalAverageOfReviewCount * 10) / 10}
            {'P'}
            {'('}
            {'過去'}
            {this.props.participant.experiencesCount}
            {'件'} {')'}
          </p>
        </div>
      );
    } else {
      return (
        <div className="col-sm-2 taskImage">
          <div
            className="task-icon task-icon-in-detail"
            style={{ backgroundImage: `url(${user.photoId})` }}
          ></div>
          <div className="rating">
            <i class="fas fa-star"></i>
            <span>
              {'   '}
              {Math.round(this.props.participant.finalAverageOfReviewCount * 10) / 10}
              {'P'} {'('}
              {'過去'}
              {this.props.participant.experiencesCount}
              {'件'} {')'}
            </span>
          </div>
        </div>
      );
    }
  };
  render = () => {
    // console.log('participant', this.props)
    console.log('TCL: ParticipantCard -> render -> this.props.noBtn', this.props.participant);
    const name = this.props.isFrom === 'modal' ? 'task-modal-open' : 'task-modal-close';
    return (
      <div className={name}>
        <div className={'participant-card' + (this.props.noBtn ? ' no-btn' : ' ')}>
          <div className="row">
            {this._renderImage(this.props.participant)}
            <div className="col-sm-10">
              <div className="row">
                <div className="col-sm-5">
                  <div className="applicant-middle">
                    <ul>
                      <li>
                        <h3>氏名 :</h3>
                        <h4>{this._renderName()}</h4>
                      </li>
                      <li>
                        <h3>性別 :</h3>
                        <h4>{this.props.participant.sex}</h4>
                      </li>
                      <li>
                        <h3>年齢 :</h3>
                        <h4>{this.props.participant.age}</h4>
                      </li>
                      <li>
                        <h3>電話番号 :</h3>
                        <h4>{this.props.participant.phone}</h4>
                      </li>
                      <li>
                        <h3>メール :</h3>
                        <h4>{this.props.participant.email}</h4>
                      </li>
                      <li>
                        <h3>保有資格 :</h3>
                        <h4>
                          {this.props.participant.licenseDetail.length > 0
                            ? Array.prototype.map
                                .call(this.props.participant.licenseDetail, function(item) {
                                  return item.value;
                                })
                                .join(', ')
                            : 'なし'}
                        </h4>
                      </li>
                      <li>
                        <h3>実績 :</h3>
                        <h4>{this.props.participant.experiencesCount}</h4>
                      </li>
                      <li>
                        <h3>キャンセル回数 :</h3>
                        <h4>{this.props.participant.taskCancelCount}</h4>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-sm-7">
                  <div className="work-block">
                    <ul>
                      <li>
                        <h3>実施可能仕事カテゴリ</h3>
                        <h4>
                          {(() => {
                            if (
                              this.props.participant.taskCategoryDetail &&
                              this.props.participant.taskCategoryDetail.length > 0
                            ) {
                              return this.props.participant.taskCategoryDetail.map((cat, i) => {
                                const last =
                                  i + 1 === this.props.participant.taskCategoryDetail.length;
                                let text;
                                if (last) {
                                  text = cat.value;
                                } else {
                                  text = `${cat.value}/`;
                                }
                                return <span key={i}>{text}</span>;
                              });
                            }
                            return <span>-</span>;
                          })()}
                        </h4>
                      </li>
                      <li>
                        <h3>希望事業者カテゴリ</h3>
                        <h4>
                          {(() => {
                            if (
                              this.props.participant.enterpriseCategoryDetail &&
                              this.props.participant.enterpriseCategoryDetail.length > 0
                            ) {
                              return this.props.participant.enterpriseCategoryDetail.map(
                                (cat, i) => {
                                  const last =
                                    i + 1 ===
                                    this.props.participant.enterpriseCategoryDetail.length;
                                  let text;
                                  if (last) {
                                    text = cat.value;
                                  } else {
                                    text = `${cat.value}/`;
                                  }
                                  return <span key={i}>{text}</span>;
                                }
                              );
                            }
                            return <span>-</span>;
                          })()}
                        </h4>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-sm-12 description-block-task">
                  <div className="self-intro">
                    <ul>
                      <li>
                        <h3>自己紹介</h3>
                        <h4>{this.props.participant.selfIntintroduction}</h4>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="col-sm-12 description-block-modal">
              <div className="self-intro">
                <ul>
                  <li>
                    <h3>自己紹介/備考</h3>
                    <h4>{this.props.participant.selfIntintroduction}</h4>
                  </li>
                </ul>
              </div>
            </div> */}
          <div className="col-sm-12">
            <div className="taskdetails-button">
              <div className="button-inner">{this._renderBtn()}</div>
            </div>
          </div>
          {this._renderOldReview()}
        </div>
      </div>
    );
  };
}
